import API from './API.ts'

export default {
  //
  // GET
  //
  getProductGroupSales ({ startDate, endDate, registerId }) {
    return API.dashboardHttpClient.get('statistics/product-group-sales', {
      params: {
        register_id: registerId,
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getBookingsPerChannel ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/bookings-per-channel', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCheckInsByUser ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/checkins-by-user', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCheckoutsByUser ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/checkouts-by-user', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCheckinsAndCheckoutsPerHour ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/checkins-and-checkouts-per-hour', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getScbExports () {
    return API.httpClient.get('scb/exports')
  },
  getMonthlyCheckinsAndCheckouts (month) {
    return API.dashboardHttpClient.get('statistics/monthly-checkins-and-checkouts', {
      params: {
        month: month.format('YYYY-MM-DD')
      }
    })
  },
  getYearlyCheckinsAndCheckouts (year) {
    return API.dashboardHttpClient.get('statistics/yearly-checkins-and-checkouts', {
      params: {
        year: year.format('YYYY')
      }
    })
  },
  getCheckedInCustomers () {
    return API.dashboardHttpClient.get('statistics/checked-in-customers')
  },
  getCustomerCounts () {
    return API.dashboardHttpClient.get('statistics/customer-counts')
  },
  getCustomerNationalityNights () {
    return API.dashboardHttpClient.get('statistics/customer-nationality-nights')
  },
  getRevenueNumbers () {
    return API.dashboardHttpClient.get('statistics/revenue-numbers')
  },
  getCategoryOccupation () {
    return API.dashboardHttpClient.get('statistics/category-occupation')
  },
  getAccommodationValue () {
    return API.dashboardHttpClient.get('statistics/accommodation-value')
  },
  getAverageBookingValue ({ startDate, endDate, period, years, allYears = false, categoryIds = [] } = {}) {
    return API.dashboardHttpClient.get('statistics/average-booking-value', {
      params: {
        start_date: startDate?.format('YYYY-MM-DD'),
        end_date: endDate?.format('YYYY-MM-DD'),
        period,
        years,
        all_years: allYears ? 1 : undefined,
        category_ids: categoryIds
      }
    })
  },
  getWeatherForecast () {
    return API.dashboardHttpClient.get('weather-forecast')
  },
  getBathingWaterTemperatures ({ pinnedIds, nearbyResultsLimit }) {
    return API.dashboardHttpClient.get('statistics/bathing-water-temperatures', {
      params: {
        pinned_ids: pinnedIds,
        limit: 30,
        nearby_results_limit: nearbyResultsLimit
      }
    })
  },
  getBathingWaterMeasurementAvailability (locationIds) {
    return API.dashboardHttpClient.get('statistics/bathing-water-quality-availability', {
      params: {
        location_ids: locationIds
      }
    })
  },
  getHistoricalTurnoverFullAccrual () {
    return API.dashboardHttpClient.get('statistics/historical-turnover-full-accrual')
  },
  getHistoricalTurnoverPartAccrual () {
    return API.dashboardHttpClient.get('statistics/historical-turnover-part-accrual')
  },
  getOccupancyStats ({ excludedCategoryIds = [], years = [] } = {}) {
    return API.dashboardHttpClient.get('statistics/occupancy-stats', {
      params: {
        excluded_category_ids: excludedCategoryIds,
        years
      }
    })
  },
  getBookingStats ({ categoryIds = [], period = 'month', years = [] } = {}) {
    return API.dashboardHttpClient.get('statistics/booking-stats', {
      params: {
        category_ids: categoryIds,
        period,
        years
      }
    })
  },
  getPositionTurnover ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/position-turnover', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCategoryTurnover ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/category-turnover', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getYearlyGuestNightsSummary (year) {
    return API.dashboardHttpClient.get('statistics/yearly-guest-nights-summary', {
      params: {
        year
      }
    })
  },
  getPositionOccupation ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/position-occupation', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getCategoryOccupationInInterval ({ startDate, endDate }) {
    return API.dashboardHttpClient.get('statistics/category-occupation-in-interval', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    })
  },
  getStayDurations ({ startDate, endDate, includeSeason }) {
    return API.dashboardHttpClient.get('statistics/stay-durations', {
      params: {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD'),
        exclude_season: !includeSeason
      }
    })
  },
  getFullyBookedDays ({ year }) {
    return API.dashboardHttpClient.get('statistics/fully-booked-days', {
      params: {
        year
      }
    })
  },

  //
  // POST
  //
  createScbExport (month) {
    return API.httpClient.post('scb/create', {
      month: month.format('YYYY-MM-DD')
    })
  },
  confirmScbExport (scbExportId) {
    return API.httpClient.post('scb/confirm', {
      scb_export_id: scbExportId
    })
  }
}
